
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/insights/[category]",
      function () {
        return require("private-next-pages/insights/[category]/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/insights/[category]"])
      });
    }
  